/**
 * Template: Page - History
 * ------------------------------------------------------------------------------
 */
import {load} from '@shopify/theme-sections';
import '../sections/page-history';
import '../../styles/templates/page.history.scss';

document.addEventListener('DOMContentLoaded', () => {
  load('page-history');
});
